<script>
  import solicitacaoReembolsoServico from '../servico';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import ModalProtocolos from '~componentes/ModalProtocolos.vue';
  import ModalPrestacaoContas from './ModalPrestacaoContas.vue';
  import tipoUsuario from '~js/tipo-usuario';
  import projetoServico from '~modulos/projeto/servico';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  const DIAS_ALERTA_PRAZO = 15;

  const SECOES = [
    { nivel: 'rejeitada', label: 'REJEITADAS · REENVIAR PRESTAÇÃO', classe: 'secao-rejeitada', linha: 'linha-rejeitada' },
    { nivel: 'vencida', label: 'PRAZO VENCIDO', classe: 'secao-rejeitada', linha: 'linha-rejeitada' },
    { nivel: 'vencendo', label: `PRAZO TERMINANDO (ATÉ ${DIAS_ALERTA_PRAZO} DIAS)`, classe: 'secao-terminando', linha: 'linha-terminando' },
    { nivel: 'pendente', label: 'A PRESTAR CONTAS · NO PRAZO', classe: 'secao-pendente', linha: '' },
    { nivel: 'enviada', label: 'PRESTADAS · AGUARDANDO CONFERÊNCIA', classe: 'secao-enviada', linha: 'linha-enviada' },
    { nivel: 'aceita', label: 'ACEITAS', classe: 'secao-aceita', linha: 'linha-aceita' },
  ];

  const ABAS = [
    { valor: 'pendentes', label: 'Pendentes', niveis: ['rejeitada', 'vencida', 'vencendo', 'pendente'] },
    { valor: 'fundacao', label: 'Com a fundação', niveis: ['enviada'] },
    { valor: 'aceitas', label: 'Aceitas', niveis: ['aceita'] },
    { valor: 'todas', label: 'Todas', niveis: SECOES.map(s => s.nivel) },
  ];

  const PRESTACAO = {
    rejeitada: { rotulo: 'Rejeitada', classe: 'bolinha-rejeitada' },
    pendente: { rotulo: 'Sem prestação', classe: 'bolinha-pendente' },
    enviada: { rotulo: 'Em conferência', classe: 'bolinha-enviada' },
    aceita: { rotulo: 'Aceita', classe: 'bolinha-aceita' },
  };

  const normalizar = texto => String(texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

  export default {
    name: 'SolicitacaoReembolsoPendentesLista',
    components: { ModalMensagem, ModalProtocolos, ModalPrestacaoContas },
    data() {
      return {
        abas: ABAS,
        aba: 'pendentes',
        filtros: { idProjeto: '0', nome: '', documento: '' },
        projetos: [],
        solicitacoes: [],
        carregando: true,
        solicitacaoSelecionada: null,
        animated: true,
        configuracao: this.$storage.configuracao(),
        modalMensagem: false,
        modalProtocolos: false,
        modalPrestacao: false,
        prestacaoSelecionada: null,
        diasAlertaPrazo: DIAS_ALERTA_PRAZO,
        usuario: this.$storage.usuario(),
      }
    },
    computed: {
      bloqueioPessoaFisica() {
        const item = (this.solicitacoes || []).find(solicitacao => solicitacao.bloqueioPessoa);

        return item ? item.bloqueioPessoa : '';
      },
      pessoaFisica() {
        return this.usuario.tipoUsuario === tipoUsuario.PessoaFisica;
      },
      coordenador() {
        return this.usuario.tipoUsuario === tipoUsuario.Coordenador;
      },
      abaAtual() {
        return this.abas.find(a => a.valor === this.aba) || this.abas[0];
      },
      documentoFiltroFormatado() {
        const cpf = this.filtros.documento || '';
        if (cpf.length !== 11) {
          return cpf;
        }
        return `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, 3)}-${cpf.substr(9, 2)}`;
      },
      usarMensageria() {
        return !this.pessoaFisica && !this.configuracao.naoUtilizarMensageria && !this.configuracao.desativarMensageriaSolReembolso;
      },
      totalColunas() {
        return 13 + (this.pessoaFisica ? 0 : 1) + (this.configuracao.criarProtocoloSolicitacao ? 1 : 0);
      },
      hojeMs() {
        const hoje = new Date();
        return new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()).getTime();
      },
      solicitacoesFiltradas() {
        const nome = normalizar(this.filtros.nome).trim();

        if (!this.coordenador || !nome) {
          return this.solicitacoes;
        }

        return this.solicitacoes.filter(s => normalizar(s.nomeTerceiro).includes(nome));
      },
      quantidadePorNivel() {
        const quantidade = {};
        for (const secao of SECOES) {
          quantidade[secao.nivel] = 0;
        }
        for (const solicitacao of this.solicitacoesFiltradas) {
          quantidade[this.nivel(solicitacao)]++;
        }
        return quantidade;
      },
      quantidadePorAba() {
        const quantidade = {};
        for (const aba of this.abas) {
          quantidade[aba.valor] = aba.niveis.reduce((soma, nivel) => soma + this.quantidadePorNivel[nivel], 0);
        }
        return quantidade;
      },
      quantidadeGrave() {
        return this.quantidadePorNivel.rejeitada + this.quantidadePorNivel.vencida;
      },
      quantidadeParaPrestar() {
        return this.quantidadePorAba.pendentes;
      },
      linhasComCabecalhos() {
        const itens = [];

        for (const secao of SECOES) {
          if (!this.abaAtual.niveis.includes(secao.nivel)) continue;

          const lista = this.solicitacoesFiltradas.filter(s => this.nivel(s) === secao.nivel);
          if (!lista.length) continue;

          if (['rejeitada', 'vencida', 'vencendo', 'pendente'].includes(secao.nivel)) {
            lista.sort((a, b) => this.prazoMs(a) - this.prazoMs(b));
          }

          itens.push({ tipo: 'cabecalho', secao, quantidade: lista.length });
          for (const solicitacao of lista) {
            itens.push({ tipo: 'linha', solicitacao, secao });
          }
        }

        return itens;
      },
      totalLinhas() {
        return this.linhasComCabecalhos.filter(i => i.tipo === 'linha').length;
      },
    },
    methods: {
      lista() {
        this.carregando = true;
        this.solicitacoes = [];

        const filtros = this.coordenador ? this.filtros : {};

        return solicitacaoReembolsoServico.listaPendentes(0, filtros)
          .then(res => {
            this.carregando = false;
            this.solicitacoes = res.body;
          })
          .catch(erro => {
            this.carregando = false;
            this.$mensagemErro(erro, 'Erro ao carregar a lista.');
          });
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao('SolReembolsoAtividade')
          .then(projetos => {
            this.projetos = projetos;
            this.$nextTick(() => {
              $('#projeto').val(this.filtros.idProjeto).trigger('change.select2');
            });
          });
      },
      escolherAba(valor) {
        this.aba = valor;
      },
      limparFiltros() {
        const recarregar = this.filtros.idProjeto !== '0' || !!this.filtros.documento;

        this.filtros = { idProjeto: '0', nome: '', documento: '' };
        $('#projeto').val('0').trigger('change.select2');

        if (Object.keys(this.$route.query).length) {
          this.$router.replace({ name: this.$route.name });
          return;
        }

        if (recarregar) {
          this.lista();
        }
      },
      aplicarQuery(query) {
        const mostrar = this.abas.find(a => a.valor === query.mostrar);
        const nivelLegado = String(query.niveis || query.nivel || '').split(',')[0];
        const abaDoNivel = this.abas.find(a => a.valor !== 'todas' && a.niveis.includes(nivelLegado));
        const cpf = String(query.documento || '').replace(/\D/g, '');

        if (mostrar) {
          this.aba = mostrar.valor;
        } else if (abaDoNivel) {
          this.aba = abaDoNivel.valor;
        }

        if (this.coordenador && cpf) {
          this.aba = 'todas';
          this.filtros.idProjeto = '0';
          this.filtros.nome = '';
          this.filtros.documento = cpf;
        }

        if (query.abrir) {
          this.abrirPrestacao(query.abrir);
        }
      },
      limparFiltroBeneficiario() {
        this.filtros.documento = '';

        if (this.$route.query.documento) {
          this.$router.replace({ name: this.$route.name });
          return;
        }

        this.lista();
      },
      prazoMs(solicitacao) {
        if (!solicitacao.dataLimitePrestacao) {
          return Number.MAX_SAFE_INTEGER;
        }
        const prazo = new Date(solicitacao.dataLimitePrestacao);
        return new Date(prazo.getFullYear(), prazo.getMonth(), prazo.getDate()).getTime();
      },
      diasParaPrazo(solicitacao) {
        if (!solicitacao.dataLimitePrestacao) {
          return null;
        }
        return Math.round((this.prazoMs(solicitacao) - this.hojeMs) / 86400000);
      },
      nivel(solicitacao) {
        const situacao = this.situacaoPrestacao(solicitacao);
        if (situacao !== 'pendente') {
          return situacao;
        }

        const dias = this.diasParaPrazo(solicitacao);
        if (dias === null) {
          return 'pendente';
        }
        if (dias < 0) {
          return 'vencida';
        }
        if (dias <= DIAS_ALERTA_PRAZO) {
          return 'vencendo';
        }
        return 'pendente';
      },
      textoPrazo(solicitacao) {
        const situacao = this.situacaoPrestacao(solicitacao);
        if (situacao === 'aceita' || situacao === 'enviada') {
          return '';
        }

        const dias = this.diasParaPrazo(solicitacao);
        if (dias === null) {
          return '';
        }
        if (dias < 0) {
          return -dias === 1 ? 'venceu há 1 dia' : `venceu há ${-dias} dias`;
        }
        if (dias === 0) {
          return 'vence hoje';
        }
        return dias === 1 ? 'vence amanhã' : `faltam ${dias} dias`;
      },
      status(solicitacao) {
        if (solicitacao.liberacaoCoordenador && solicitacao.statusSolicitacao === 0) {
          return 'Liberada pelo coordenador';
        } else if (solicitacao.statusSolicitacao === 1) {
          return 'Liberada pela instituição';
        } else if (solicitacao.statusSolicitacao === 2) {
          return 'Cancelada pela instituição';
        } else if (solicitacao.statusSolicitacao === 3 || solicitacao.statusSolicitacao === 4 || solicitacao.statusSolicitacao === 5) {
          return 'Cancelada pelo coordenador';
        } else {
          return 'Aguardando liberação';
        }
      },
      iconeTipo(tipo) {
        if (tipo === 0) {
          return 'fa-plane';
        }
        if (tipo === 1) {
          return 'fa-calendar';
        }

        return 'fa-money';
      },
      tipo(tipo) {
        if (tipo === 0) {
          return 'Passagem';
        }
        if (tipo === 1) {
          return 'Diária';
        }

        return 'Adiantamento';
      },
      situacaoPrestacao(solicitacao) {
        if (solicitacao.dataHoraAceitoPrestConta) {
          return 'aceita';
        }
        if (solicitacao.motivoRejeicao) {
          return 'rejeitada';
        }
        if (solicitacao.dataHoraAtividade) {
          return 'enviada';
        }
        return 'pendente';
      },
      prestacao(solicitacao) {
        return PRESTACAO[this.situacaoPrestacao(solicitacao)];
      },
      dicaPrestacao(solicitacao) {
        const situacao = this.situacaoPrestacao(solicitacao);
        const data = valor => this.$options.filters.formatarData(valor);

        if (situacao === 'rejeitada') {
          return `Rejeitada${solicitacao.conferidoPor ? ' por ' + solicitacao.conferidoPor : ''} · Motivo: ${solicitacao.motivoRejeicao}`;
        }
        if (situacao === 'enviada') {
          return `Enviada em ${data(solicitacao.dataHoraAtividade)}${solicitacao.prestadoPor ? ' por ' + solicitacao.prestadoPor : ''}`;
        }
        if (situacao === 'aceita') {
          return `Aceita em ${data(solicitacao.dataHoraAceitoPrestConta)}${solicitacao.conferidoPor ? ' por ' + solicitacao.conferidoPor : ''}`;
        }
        return 'Ainda não enviada';
      },
      podePrestar(solicitacao) {
        const situacao = this.situacaoPrestacao(solicitacao);

        return situacao === 'pendente' || situacao === 'rejeitada';
      },
      classePrazo(solicitacao) {
        const nivel = this.nivel(solicitacao);

        return {
          'prazo-vencido': nivel === 'vencida',
          'prazo-terminando': nivel === 'vencendo',
        };
      },
      abrirPrestacao(idCript) {
        this.prestacaoSelecionada = idCript;
        this.modalPrestacao = true;
      },
      prestacaoFechada() {
        this.animated = false;
        this.modalPrestacao = false;
        this.prestacaoSelecionada = null;
        $('body').removeClass('modal-open');

        if (this.$route.query.abrir) {
          const query = Object.assign({}, this.$route.query);
          delete query.abrir;
          this.$router.replace({ name: this.$route.name, query });
        }
      },
      mostrarModalProtocolos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalProtocolos = true;
      },
      modalProtocolosFechado() {
        this.animated = false;
        this.modalProtocolos = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista();
      },
    },
    created() {
      this.aplicarQuery(this.$route.query);
      this.lista();
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Diária ${ this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' } ${ this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' } - Prestação de contas`;
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederRota = '';
      this.$root.botaoAcaoTexto = '';
      this.$root.botaoRetrocederMostrar = false;

      if (this.coordenador) {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function () {
            if (_this.filtros.idProjeto === this.value) return;

            _this.$set(_this.filtros, 'idProjeto', this.value);
            _this.lista();
          });

        this.listaDeProjetos();
      }
    },
    watch: {
      '$route'(para, de) {
        const soFechouModal = de && de.query.abrir && !para.query.abrir
          && para.query.mostrar === de.query.mostrar
          && para.query.documento === de.query.documento;

        if (soFechouModal) return;

        this.aplicarQuery(para.query);
        this.lista();
      },
    },
  }
</script>

<style scoped>
  .linha-carregando {
    padding: 24px 10px !important;
    color: #5d6062;
  }

  .table td {
    vertical-align: middle;
  }

  .painel-resumo {
    padding: 16px 20px;
    border-radius: 4px;
    margin-bottom: 15px;
    border-left: 5px solid;
    font-size: 1.05em;
  }
  .painel-atencao {
    background-color: #fdecea;
    border-left-color: #d9534f;
    color: #6b1f1c;
  }
  .painel-pendente {
    background-color: #fcf8e3;
    border-left-color: #f0ad4e;
    color: #7a5a1b;
  }
  .painel-em-dia {
    background-color: #dff0d8;
    border-left-color: #5cb85c;
    color: #2b542c;
  }
  .painel-detalhe {
    font-size: 0.9em;
    opacity: 0.85;
    margin-top: 4px;
    margin-left: 22px;
  }

  .filtro-beneficiario {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .barra-situacao {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;
  }

  .barra-separada {
    border-top: 1px solid #e7eaec;
    margin-left: -20px;
    margin-right: -20px;
    padding: 15px 20px 0;
  }

  .barra-situacao-titulo {
    font-weight: 600;
    margin-right: 6px;
  }

  .barra-situacao-ajuda {
    margin-left: auto;
    color: #6b6e70;
  }

  .btn-situacao {
    height: 34px;
    background: #fff;
    border: 1px solid #c9cdd0;
    color: #4f5254;
  }

  .btn-situacao.ativa {
    background: #2f4050;
    border-color: #2f4050;
    color: #fff;
  }

  .btn-situacao .badge {
    margin-left: 4px;
    background-color: #e4e6e8;
    color: #3d4043;
  }

  .btn-situacao.ativa .badge {
    background-color: #fff;
    color: #2f4050;
  }

  .linha-separador-secao > td {
    font-size: 0.85em;
    font-weight: 700;
    letter-spacing: 1.5px;
    padding: 7px 10px;
    background-color: #f5f5f5;
    border-top: 2px solid #ccc;
    color: #555;
  }
  .linha-separador-secao.secao-rejeitada > td {
    background-color: #fdf2f0;
    color: #8a3a3a;
    border-top-color: #d9534f;
  }
  .linha-separador-secao.secao-terminando > td {
    background-color: #fbf6e6;
    color: #6a4c12;
    border-top-color: #f0ad4e;
  }
  .linha-separador-secao.secao-pendente > td {
    background-color: #f9f9f9;
    color: #555;
    border-top-color: #b8bcc0;
  }
  .linha-separador-secao.secao-enviada > td {
    background-color: #eef5fb;
    color: #1f4f73;
    border-top-color: #1c84c6;
  }
  .linha-separador-secao.secao-aceita > td {
    background-color: #f7f7f7;
    color: #666;
  }

  tr.linha-rejeitada > td {
    background-color: #f9e4e4;
  }

  tr.linha-terminando > td {
    background-color: #fcf6e1;
  }

  tr.linha-enviada > td {
    background-color: #eef5fb;
  }

  tr.linha-aceita > td {
    background-color: #eef7ea;
  }

  .tabela-prestacao > tbody > tr > td {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .coluna-numero {
    font-weight: 600;
    white-space: nowrap;
  }

  .coluna-data,
  .coluna-tipo,
  .coluna-acao,
  .coluna-prestacao {
    white-space: nowrap;
  }

  .coluna-tipo .fa {
    color: #2f4050;
    margin-right: 2px;
  }

  .valor {
    font-weight: 600;
    white-space: nowrap;
  }

  .prazo-vencido {
    color: #a33a37;
    font-weight: 700;
  }

  .prazo-terminando {
    color: #7a5a1b;
  }

  .bolinha {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin-right: 4px;
  }
  .bolinha-rejeitada {
    background-color: #ed5565;
  }
  .bolinha-pendente {
    background-color: #f8c75a;
  }
  .bolinha-enviada {
    background-color: #1c84c6;
  }
  .bolinha-aceita {
    background-color: #1d9d74;
  }

  .btn-linha {
    position: relative;
    height: 30px;
    width: 30px;
    padding: 0;
  }

  .badge-nao-lida {
    position: absolute;
    top: -6px;
    right: -6px;
    background-color: #c9302c;
    color: #fff;
    font-size: 9px;
    padding: 2px 5px;
  }

  .label-bloqueio {
    display: inline-block;
    margin-left: 4px;
    background-color: #fdecea;
    border: 1px solid #e4b9b6;
    color: #a13c3c;
    font-size: 10px;
    font-weight: 700;
    cursor: help;
  }

  .alert-bloqueio {
    background-color: #fdf5f4;
    border: 1px solid #f0d2cf;
    color: #6b1f1c;
  }

  .alert-bloqueio .label-bloqueio {
    margin-left: 0;
    margin-right: 6px;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-protocolos :mostrar="modalProtocolos"
                      :numeroProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.numeroProtocolo : ''"
                      @fechado="modalProtocolosFechado">
    </modal-protocolos>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoReembolso : ''"
                    tipo="SolReembolso"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <modal-prestacao-contas :mostrar="modalPrestacao"
                            :id="prestacaoSelecionada"
                            @enviado="lista"
                            @fechado="prestacaoFechada">
    </modal-prestacao-contas>

    <div class="row" v-if="!carregando">
      <div class="col-lg-12">
        <div :class="['painel-resumo', quantidadeGrave > 0 ? 'painel-atencao' : (quantidadeParaPrestar > 0 ? 'painel-pendente' : 'painel-em-dia')]">
          <template v-if="quantidadeGrave > 0">
            <div>
              <i class="fa fa-exclamation-triangle"></i>
              <template v-if="quantidadePorNivel.rejeitada > 0">
                <strong>{{ quantidadePorNivel.rejeitada }}</strong>
                {{ quantidadePorNivel.rejeitada === 1 ? 'prestação rejeitada' : 'prestações rejeitadas' }}
              </template>
              <template v-if="quantidadePorNivel.rejeitada > 0 && quantidadePorNivel.vencida > 0"> e </template>
              <template v-if="quantidadePorNivel.vencida > 0">
                <strong>{{ quantidadePorNivel.vencida }}</strong>
                {{ quantidadePorNivel.vencida === 1 ? 'solicitação com prazo vencido' : 'solicitações com prazo vencido' }}
              </template>
            </div>
            <div class="painel-detalhe" v-if="quantidadePorNivel.vencendo > 0">
              e mais {{ quantidadePorNivel.vencendo }} com prazo terminando nos próximos {{ diasAlertaPrazo }} dias
            </div>
          </template>
          <template v-else-if="quantidadeParaPrestar > 0">
            <div>
              <i class="fa fa-clock-o"></i>
              <strong>{{ quantidadeParaPrestar }}</strong>
              {{ quantidadeParaPrestar === 1 ? 'solicitação aguardando prestação de contas' : 'solicitações aguardando prestação de contas' }}
            </div>
            <div class="painel-detalhe" v-if="quantidadePorNivel.vencendo > 0">
              {{ quantidadePorNivel.vencendo }} com prazo terminando nos próximos {{ diasAlertaPrazo }} dias
            </div>
          </template>
          <div v-else>
            <i class="fa fa-check-circle"></i>
            Nenhuma prestação de contas pendente.
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="alert alert-bloqueio" v-if="pessoaFisica && bloqueioPessoaFisica">
              <span class="label label-bloqueio"><i class="fa fa-lock"></i> Bloqueio</span>
              {{ bloqueioPessoaFisica }}
            </div>

            <div class="alert alert-info filtro-beneficiario" v-if="coordenador && filtros.documento">
              <span>
                <i class="fa fa-filter"></i>
                Mostrando apenas as solicitações do beneficiário <strong>{{ documentoFiltroFormatado }}</strong>.
              </span>
              <button type="button" class="btn btn-xs btn-default" @click="limparFiltroBeneficiario">
                <i class="fa fa-times"></i> Limpar filtro
              </button>
            </div>

            <div class="row" v-if="coordenador">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>
                  <select id="projeto" class="form-control">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="projeto in projetos" :key="projeto.idProjeto">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label" for="nome-pessoa">Nome da pessoa</label>
                  <input id="nome-pessoa"
                         type="text"
                         class="form-control"
                         placeholder="Digite parte do nome do beneficiário"
                         v-model="filtros.nome">
                </div>
              </div>
            </div>

            <div class="row" v-if="coordenador">
              <div class="col-xs-12">
                <div class="form-group">
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i> Limpar filtros
                  </button>
                </div>
              </div>
            </div>

            <div :class="['barra-situacao', { 'barra-separada': coordenador }]">
              <span class="barra-situacao-titulo">Mostrar</span>
              <button v-for="opcao in abas"
                      :key="opcao.valor"
                      type="button"
                      :class="['btn', 'btn-situacao', { 'ativa': aba === opcao.valor }]"
                      @click="escolherAba(opcao.valor)">
                {{ opcao.label }}
                <span v-if="opcao.valor !== 'todas'" class="badge">{{ quantidadePorAba[opcao.valor] }}</span>
              </button>
              <small class="barra-situacao-ajuda">O que você prestar sai de Pendentes e vai para Com a fundação</small>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered tabela-prestacao">
                <thead>
                  <tr>
                    <th class="text-center">Número</th>
                    <th>Data solicitação</th>
                    <th>Solicitante</th>
                    <th>Projeto</th>
                    <th v-if="!pessoaFisica">Beneficiário</th>
                    <th>Vencimento</th>
                    <th>Previsão</th>
                    <th>Efetivação</th>
                    <th class="text-right">Valor (R$)</th>
                    <th>Tipo</th>
                    <th v-if="configuracao.criarProtocoloSolicitacao">Protocolo</th>
                    <th>Status</th>
                    <th>Prazo prestação</th>
                    <th>Prestação de contas</th>
                    <th class="text-center">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, indice) in linhasComCabecalhos">
                  <tr v-if="item.tipo === 'cabecalho'"
                      :key="'h-' + item.secao.nivel"
                      :class="['linha-separador-secao', item.secao.classe]">
                    <td :colspan="totalColunas">{{ item.secao.label }} ({{ item.quantidade }})</td>
                  </tr>
                  <tr v-else
                      :key="item.solicitacao.idSolicitacaoReembolso + '-' + indice"
                      :class="item.secao.linha">
                    <td class="text-center coluna-numero">{{ item.solicitacao.idSolicitacaoReembolso || '---' }}</td>
                    <td class="coluna-data">{{ item.solicitacao.dataSolicitacao | formatarData }} {{ item.solicitacao.dataSolicitacao | formatarHora }}</td>
                    <td>{{ item.solicitacao.solicitante || '---' }}</td>
                    <td>
                      {{ item.solicitacao.nomeProjeto || '---' }}
                      <span v-if="item.solicitacao.bloqueioProjeto" class="label label-bloqueio" v-tooltip="item.solicitacao.bloqueioProjeto">
                        <i class="fa fa-lock"></i> Bloqueio
                      </span>
                    </td>
                    <td v-if="!pessoaFisica">
                      {{ item.solicitacao.nomeTerceiro || '---' }}
                      <span v-if="item.solicitacao.bloqueioPessoa" class="label label-bloqueio" v-tooltip="item.solicitacao.bloqueioPessoa">
                        <i class="fa fa-lock"></i> Bloqueio
                      </span>
                    </td>
                    <td class="coluna-data">{{ item.solicitacao.dataVencimento | formatarData('---') }}</td>
                    <td class="coluna-data">{{ item.solicitacao.dataPrevisao | formatarData('---') }}</td>
                    <td class="coluna-data">{{ item.solicitacao.dataLancamento | formatarData('---') }}</td>
                    <td class="text-right valor">{{ item.solicitacao.valor | formatarNumero }}</td>
                    <td class="coluna-tipo"><i :class="['fa', iconeTipo(item.solicitacao.tipoReembolso)]"></i> {{ tipo(item.solicitacao.tipoReembolso) }}</td>
                    <td v-if="configuracao.criarProtocoloSolicitacao">
                      <a @click.prevent="mostrarModalProtocolos(item.solicitacao)" v-if="item.solicitacao.numeroProtocolo">{{ item.solicitacao.numeroProtocolo }} <i class="fa fa-external-link"></i></a>
                      <span v-if="!item.solicitacao.numeroProtocolo">---</span>
                    </td>
                    <td>{{ status(item.solicitacao) }}</td>
                    <td class="coluna-data" :class="classePrazo(item.solicitacao)">
                      {{ item.solicitacao.dataLimitePrestacao | formatarData('---') }}
                      <small v-if="textoPrazo(item.solicitacao)">({{ textoPrazo(item.solicitacao) }})</small>
                    </td>
                    <td class="coluna-prestacao">
                      <span v-tooltip="dicaPrestacao(item.solicitacao)">
                        <span :class="['bolinha', prestacao(item.solicitacao).classe]"></span>
                        {{ prestacao(item.solicitacao).rotulo }}
                      </span>
                    </td>
                    <td class="text-center coluna-acao">
                      <button type="button"
                              :class="['btn', 'btn-linha', podePrestar(item.solicitacao) ? 'btn-primary' : 'btn-default']"
                              v-tooltip="podePrestar(item.solicitacao) ? 'Prestar contas' : 'Ver prestação de contas'"
                              :aria-label="podePrestar(item.solicitacao) ? 'Prestar contas' : 'Ver prestação de contas'"
                              @click="abrirPrestacao(item.solicitacao.idSolicitacao)">
                        <i :class="['fa', podePrestar(item.solicitacao) ? 'fa-pencil' : 'fa-eye']"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-linha"
                              v-tooltip="'Ler/enviar mensagem'"
                              aria-label="Ler ou enviar mensagem"
                              @click="mostrarModalMensagem(item.solicitacao)"
                              v-if="usarMensageria">
                        <i class="fa fa-comment"></i>
                        <span class="badge badge-nao-lida" v-if="item.solicitacao.quantidadeNaoLida > 0">{{ item.solicitacao.quantidadeNaoLida }}</span>
                      </button>
                    </td>
                  </tr>
                  </template>
                  <tr v-show="carregando">
                    <td :colspan="totalColunas" class="text-center linha-carregando">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                  <tr v-show="!totalLinhas && !carregando">
                    <td :colspan="totalColunas" class="text-center">Nenhuma solicitação encontrada.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-atividade/componentes/SolicitacaoReembolsoAtividadeLista.vue